"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSScheduleReservationComponent = void 0;
const helper_service_1 = require("../services/helper.service");
class CSScheduleReservationComponent {
    constructor(helperService) {
        this.helperService = helperService;
    }
    scheduleReservation() {
        this.helperService.onNavigate('/slp/reservations/');
    }
}
exports.CSScheduleReservationComponent = CSScheduleReservationComponent;
//# sourceMappingURL=schedulereservation.component.js.map